import Login from "pages/Login.js";
import Letters from "pages/Letter/Letters.js";
import LetterForm from "pages/Letter/LetterForm.js";
import LetterDetails from "pages/Letter/LetterDetails.js";
import Payments from "pages/Payment/Payments.js";
import PaymentForm from "pages/Payment/PaymentForm.js";
import PaymentDetails from "pages/Payment/PaymentDetails.js";
import Commissions from "pages/Commission/Commissions.js";
import CommissionDetails from "pages/Commission/CommissionDetails.js";
import CommissionForm from "pages/Commission/CommissionForm";
import Users from "pages/User/Users.js";
import UserForm from "pages/User/UserForm.js";
import UserDetails from "pages/User/UserDetails.js";
import Clients from "pages/Client/Clients.js";
import Sellers from "pages/Seller/Sellers.js";
import SellerDetails from "pages/Seller/SellerDetails.js";
import ClientForm from "pages/Client/ClientForm.js";
import ClientDetails from "pages/Client/ClientDetails.js";
import Imports from "pages/Imports/Imports.js";
import SellerForm from "pages/Seller/SellerForm.js";
import Brokers from "pages/Broker/Brokers";
import BrokerDetails from "pages/Broker/BrokerDetails";
import BrokerForm from "pages/Broker/BrokerForm.js";
import Reports from "pages/Reports/Reports";
import Projects from "pages/Project/Projects";
import ProjectDetails from "pages/Project/ProjectDetails";
import ProjectForm from "pages/Project/ProjectForm";
import Units from "pages/Units/Units"
import UnitDetails from "pages/Units/UnitDetails";
import UnitForm from "pages/Units/UnitForm";
import ClientActions from "pages/ClientAction/ClientActions";
import ClientActionsDetails from "pages/ClientAction/ClientActionDetails";
import ClientActionsForm from "pages/ClientAction/ClientActionForm";
import YearlyIndicators from "pages/YearlyIndicators/YearlyIndicators";
import YearlyIndicatorForm from "pages/YearlyIndicators/YearlyIndicatorForm";
import Backups from "pages/Backup/Backups";

const routes = [
  {
    path: "/clients",
    name: "Clients",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: Clients,
    layout: "/dashboard",
    permission: 'ViewClient'
  },
  {
    path: "/brokers",
    name: "Brokers",
    rtlName: "",
    icon: "tim-icons icon-bank",
    component: Brokers,
    layout: "/dashboard",
    permission: 'ViewBroker'
  },
  {
    path: "/sellers",
    name: "Sellers",
    rtlName: "",
    icon: "tim-icons icon-user-run",
    component: Sellers,
    layout: "/dashboard",
    permission: 'ViewSeller'
  },
  {
    path: "/payments",
    name: "Payments",
    rtlName: "",
    icon: "tim-icons icon-money-coins",
    component: Payments,
    layout: "/dashboard",
    permission: 'ViewPayment'
  },
  {
    path: "/commissions",
    name: "Commissions",
    rtlName: "",
    icon: "tim-icons icon-money-coins",
    component: Commissions,
    layout: "/dashboard",
    permission: 'ViewCommission'
  },
  {
    path: "/letters",
    name: "Letters",
    rtlName: "",
    icon: "tim-icons icon-email-85",
    component: Letters,
    layout: "/dashboard",
    permission: 'ViewLetter'
  },
  {
    path: "/projects",
    name: "Projects",
    rtlName: "",
    icon: "tim-icons icon-paper",
    component: Projects,
    layout: "/dashboard",
    permission: 'ViewProject'
  },
  {
    path: "/units",
    name: "Units",
    rtlName: "",
    icon: "tim-icons icon-paper",
    component: Units,
    layout: "/dashboard",
    permission: 'ViewUnit'
  },
  {
    path: "/client-actions",
    name: "Client Actions",
    rtlName: "",
    icon: "tim-icons icon-email-85",
    component: ClientActions,
    layout: "/dashboard",
    permission: 'ViewClientAction'
  },
  {
    path: "/users",
    name: "Users",
    rtlName: "",
    icon: "tim-icons icon-badge",
    component: Users,
    layout: "/dashboard",
    permission: 'ViewUser'
  },
  {
    path: "/imports",
    name: "Imports",
    rtlName: "",
    icon: "tim-icons icon-upload",
    component: Imports,
    layout: "/dashboard"
  },
  {
    path: "/reports",
    name: "Reports",
    rtlName: "",
    icon: "tim-icons icon-notes",
    component: Reports,
    layout: "/dashboard"
  },
  {
    path: "/yearly-indicators",
    name: "Yearly Indicators",
    rtlName: "",
    component: YearlyIndicators,
    layout: "/dashboard",
    invisible: false,
    icon: "tim-icons icon-bullet-list-67",
    permission: ''
  },
  {
    path: "/backups",
    name: "Backups",
    rtlName: "",
    icon: "tim-icons icon-cloud-download-93",
    component: Backups,
    layout: "/dashboard"
  },
  {
    path: "/login",
    name: "Login",
    rtlName: "",
    component: Login,
    layout: "/auth",
    invisible: true
  },
  {
    path: "/user",
    name: "User Details",
    rtlName: "",
    component: UserDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewUser'
  },
  {
    path: "/user/create",
    name: "Create User",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: UserForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateUser'
  },
  {
    path: "/user/edit",
    name: "Edit User",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: UserForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditUser'
  },
  {
    path: "/client",
    name: "Client Details",
    rtlName: "",
    component: ClientDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewClient'
  },
  {
    path: "/seller",
    name: "Seller Details",
    rtlName: "",
    component: SellerDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewSeller'
  },
  {
    path: "/broker",
    name: "Broker Details",
    rtlName: "",
    component: BrokerDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewBroker'
  },
  {
    path: "/project",
    name: "Project Details",
    rtlName: "",
    component: ProjectDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewProject'
  },
  {
    path: "/project/create",
    name: "Create Project",
    rtlName: "",
    component: ProjectForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateProject'
  },
  {
    path: "/project/edit",
    name: "Edit Project",
    rtlName: "",
    component: ProjectForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditProject'
  },
  {
    path: "/unit",
    name: "Unit Details",
    rtlName: "",
    component: UnitDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewUnit'
  },
  {
    path: "/unit/create",
    name: "Create Details",
    rtlName: "",
    component: UnitForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateUnit'
  },
  {
    path: "/unit/edit",
    name: "Edit Details",
    rtlName: "",
    component: UnitForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditUnit'
  },
  {
    path: "/client/create",
    name: "Create Client",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: ClientForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateClient'
  },
  {
    path: "/seller/create",
    name: "Create Seller",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: SellerForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateSeller'
  },
  {
    path: "/broker/create",
    name: "Create Broker",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: BrokerForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateBroker'
  },
  {
    path: "/client/edit",
    name: "Edit Client",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: ClientForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditClient'
  },
  {
    path: "/seller/edit",
    name: "Edit Seller",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: SellerForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditSeller'
  },
  {
    path: "/broker/edit",
    name: "Edit Broker",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: BrokerForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditBroker'
  },
  {
    path: "/letter",
    name: "Letter Details",
    rtlName: "",
    component: LetterDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewLetter'
  },
  {
    path: "/letter/create",
    name: "Create Letter",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: LetterForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateLetter'
  },
  {
    path: "/letter/edit",
    name: "Edit Payment",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: LetterForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditLetter'
  },
  {
    path: "/payment",
    name: "Payment Details",
    rtlName: "",
    component: PaymentDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewPayment'
  },
  {
    path: "/commission",
    name: "Commission Details",
    rtlName: "",
    component: CommissionDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'ViewCommission'
  },
  {
    path: "/commission/edit",
    name: "Edit Commission",
    rtlName: "",
    component: CommissionForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditCommission'
  },
  {
    path: "/payment/create",
    name: "Create Payment",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: PaymentForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreatePayment'
  },
  {
    path: "/payment/edit",
    name: "Edit Payment",
    rtlName: "",
    icon: "tim-icons icon-single-02",
    component: PaymentForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditPayment'
  },
  {
    path: "/client-action",
    name: "Client Action Details",
    rtlName: "",
    component: ClientActionsDetails,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateClientAction'
  },
  {
    path: "/client-action/create",
    name: "Create Client Action",
    rtlName: "",
    component: ClientActionsForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'CreateClientAction'
  },
  {
    path: "/client-action/edit",
    name: "Edit Client Action",
    rtlName: "",
    component: ClientActionsForm,
    layout: "/dashboard",
    invisible: true,
    permission: 'EditClientAction'
  },
  {
    path: "/yearly-indicators/create",
    name: "Yearly Indicators",
    rtlName: "",
    component: YearlyIndicatorForm,
    layout: "/dashboard",
    invisible: true,
    permission: ''
  },
  {
    path: "/yearly-indicators/edit",
    name: "Yearly Indicators",
    rtlName: "",
    component: YearlyIndicatorForm,
    layout: "/dashboard",
    invisible: true,
    permission: ''
  }
];

export default routes;
